<template>
    <section>
        <div class="section-body" v-if="roomsShow">
            <div class="sb-inner">
                <div class="sb-part" v-for="room in roomsShow" :key="room">
                    <router-link :to="'/rooms/detail/' + room.slug">
                        <div class="sb-part-inner">
                            <div class="spi-image">
                                <img :src="room.image" :alt="'melinda cvc room - ' + room.name"/>
                            </div>
                            <div class="spi-text">
                                <div class="spi-title">
                                    <h2>{{ room.name }}</h2>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="section-more" v-if="roomsShow.length < rooms.length">
                <button @click="useRoomStore().moreRooms();">Load More</button>
            </div>
        </div>
        <RoomBoxSkeleton v-else/>
    </section>
</template>

<script setup>
    import RoomBoxSkeleton from '@/components/skeletons/sections/RoomBoxSkeleton.vue';
    import { computed } from '@vue/reactivity';
    import { useRoomStore } from '@/stores/room';
    const rooms = computed(() => useRoomStore().rooms);
    const roomsShow = computed(() => useRoomStore().roomsShow);
    useRoomStore().setRooms();
</script>

<style scoped>
    section {
  padding: 2.5rem 0;
}
.section-body {
  padding: 0 10%;
}
.sb-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}
.sb-part {
  width: calc(33.333% - 1rem);
  min-height: 260px;
  transition: transform 0.3s ease;
}
.sb-part:hover {
  transform: translateY(-4px);
}
.sb-part-inner {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}
.sb-part-inner:hover {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}
.spi-image {
  width: 100%;
  height: 100%;
}
.spi-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}
.sb-part-inner:hover img {
  transform: scale(1.05);
}
.spi-text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  color: white;
}
.spi-title h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
}

/* Load More button */
.section-more {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.section-more button {
  font-family: poppins;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.75rem 2rem;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  transition: background 0.3s ease;
}
.section-more button:hover {
  background: var(--primary-dark, #002d5e);
}

/* Responsive */
@media (max-width: 1000px) {
  .sb-part {
    width: calc(50% - 1rem);
  }
}
@media (max-width: 600px) {
  .sb-part {
    width: 100%;
  }
  .spi-title h2 {
    font-size: 1.1rem;
  }
  .section-body {
    padding: 0 2.5%;
  }
}
</style>